var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesCac07Cinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    },
    transform: "matrix(.11719 0 0 -.11719 0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-29.754a1.917 1.917 0 0 0-1.917 1.917v29.754a4.79 4.79 0 0 1-4.791 4.791h-23.726a4.79 4.79 0 0 1-4.791-4.791V1.917A1.917 1.917 0 0 0-66.896 0H-96.65a4.79 4.79 0 0 1-4.791-4.791v-23.727a4.79 4.79 0 0 1 4.791-4.791h29.754a1.917 1.917 0 0 0 1.917-1.917v-29.753a4.79 4.79 0 0 1 4.791-4.792h23.726a4.79 4.79 0 0 1 4.791 4.792v29.753c0 1.059.859 1.917 1.917 1.917H0a4.79 4.79 0 0 1 4.791 4.791v23.727A4.79 4.79 0 0 1 0 0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(466.29 218.42)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-135.182c0-20.7-16.78-37.469-37.47-37.469h-176.592c-20.69 0-37.47 16.769-37.47 37.469V82.63c0 17.27 11.67 31.801 27.56 36.15 3.43.941 5.86 4 5.86 7.561v39.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(504.5 228.04)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-39.271c0-3.56 2.43-6.62 5.86-7.56 15.89-4.35 27.56-18.88 27.56-36.15v-47.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(471.08 393.651)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-222.431c-8.036 0-14.55-6.515-14.55-14.55v-33.866c0-8.036 6.514-14.55 14.55-14.55H0c8.036 0 14.55 6.514 14.55 14.55v33.866C14.55-6.515 8.036 0 0 0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(489.95 456.616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-131.546c-22.934 0-41.526 18.592-41.526 41.525v89.819c0 22.934 18.592 41.525 41.526 41.525H0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(504.5 115.331)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-62.966",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(294.386 456.616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-62.966",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(336.56 456.616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-62.966",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(378.734 456.616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-62.966",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(420.91 456.616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-62.966",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(463.084 456.616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v74.085",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(116.585 55.384)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h97.304c20.458 0 37.042 16.585 37.042 37.042s-16.584 37.043-37.042 37.043H-46.781c-20.458 0-37.042-16.585-37.042-37.043S-67.239 0-46.781 0H-35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(91.323 55.384)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-52.386 52.386",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(191.177 191.26)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-68.255-68.255c-14.466-14.466-14.466-37.92 0-52.386 14.465-14.465 37.92-14.465 52.385 0L86.014-18.758c14.465 14.466 14.465 37.92 0 52.386s-37.92 14.466-52.387 0l-8.886-8.887",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(156.106 260.959)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesCac07Cinza);
export default __webpack_public_path__ + "static/media/Icones_cac_07_cinza.d6811afeb5ef4822bf94e18be187b14f.svg";
export { ForwardRef as ReactComponent };